import React from 'react';

export const PanelTopWrapper = (props) => (
  <div id={props.id} className={`d-flex justify-content-between align-items-center ${props.padding}`}>
    {props.children}
  </div>
);
